import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    Filter,
    TextInput,
    SelectInput,
    ReferenceInput
} from 'react-admin';
import { Chip } from '@material-ui/core';
import {useTranslation} from 'react-i18next';

const StatusField = ({ record }) => {
    const {t} = useTranslation();
    
    const getChipColor = (status) => {
        switch (status) {
            case 'queued':
                return 'primary';
            case 'sent':
                return 'success';
            case 'failed':
                return 'error';
            case 'cancelled':
                return 'default';
            case 'skipped':
                return 'warning';
            default:
                return 'default';
        }
    };

    const getStatusLabel = (status) => {
        switch (status) {
            case 'queued':
                return t('drip.enrollment.status.queued');
            case 'sent':
                return t('drip.enrollment.status.sent');
            case 'failed':
                return t('drip.enrollment.status.failed');
            case 'cancelled':
                return t('drip.enrollment.status.cancelled');
            case 'skipped':
                return t('drip.enrollment.status.skipped');
            default:
                return status;
        }
    };

    const statusValue = record.status && record.status.value ? record.status.value : record.status;
    
    return (
        <Chip 
            label={getStatusLabel(statusValue)}
            color={getChipColor(statusValue)}
            size="small"
        />
    );
};

const DripEnrollmentFilter = (props) => {
    const {t} = useTranslation();
    
    return (
        <Filter {...props}>
            <ReferenceInput 
                source="dripCampaign" 
                reference="drip-campaigns" 
                label={t('drip.enrollment.campaign')}
                alwaysOn
                allowEmpty={false}
            >
                <SelectInput optionText="name" />
            </ReferenceInput>
            <SelectInput 
                source="status.value" 
                label={t('drip.enrollment.status.label')} 
                choices={[
                    { id: 'queued', name: t('drip.enrollment.status.queued') },
                    { id: 'sent', name: t('drip.enrollment.status.sent') },
                    { id: 'failed', name: t('drip.enrollment.status.failed') },
                    { id: 'cancelled', name: t('drip.enrollment.status.cancelled') },
                    { id: 'skipped', name: t('drip.enrollment.status.skipped') }
                ]}
                allowEmpty={false}
                alwaysOn
            />
            <TextInput source="contactEmail" label={t('drip.enrollment.contact_email')} />
        </Filter>
    );
};

const DripEnrollmentList = (props) => {
    const {t} = useTranslation();

    return (
        <List
            {...props}
            title={t('drip.enrollment.list_title')}
            filters={<DripEnrollmentFilter />}
            sort={{ field: 'scheduledSendAt', order: 'ASC' }}
            perPage={25}
            bulkActionButtons={false}
            actions={false}
        >
            <Datagrid>
                <TextField 
                    source="contactEmail" 
                    label={t('drip.enrollment.contact_email')} 
                />
                <StatusField 
                    source="status" 
                    label={t('drip.enrollment.status.label')} 
                />
                <DateField 
                    source="scheduledSendAt" 
                    label={t('drip.enrollment.scheduled_send')}
                    showTime
                />
                <DateField 
                    source="enrolledAt" 
                    label={t('drip.enrollment.enrolled_at')}
                    showTime
                />
            </Datagrid>
        </List>
    );
};

export default DripEnrollmentList;